import { DashbaordLayout } from "src/layouts/dashboard/layout";

const Page = () => {
   
    return (
      <>
     
      </>
    );
  };

  Page.getLayout = (page) => (
    <DashbaordLayout>
      {page}
    </DashbaordLayout>
  );

  export default Page;